import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "12",
  height: "16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M1 13.833c0 .917.75 1.667 1.667 1.667h6.666c.917 0 1.667-.75 1.667-1.667V5.5c0-.917-.75-1.667-1.667-1.667H2.667C1.75 3.833 1 4.583 1 5.5v8.333Zm10-12.5H8.917L8.325.742A.84.84 0 0 0 7.742.5H4.258a.84.84 0 0 0-.583.242l-.592.591H1a.836.836 0 0 0-.833.834C.167 2.625.542 3 1 3h10a.836.836 0 0 0 .833-.833.836.836 0 0 0-.833-.834Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render };